import { NextPage } from 'next'
import LandingPage from 'views/landingPage'

const HomePage: NextPage = () => {
  return <LandingPage />
}

export default HomePage
